import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import MobileTabBar from "@/components/feature/MobileTabBar";

export default function SiteLayout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 pt-16 md:pt-[72px] pb-20 md:pb-0 w-full">
        <Outlet />
      </main>
      <SiteFooter />
      <MobileTabBar />
    </div>
  );
}